import React from 'react';
import { Routes, Route } from 'react-router-dom';

// --- Core Public Pages (MVP Focused) ---
import Home from './pages/public/Home';          // The main utility/tracker page
import ContactPage from './pages/public/ContactPage';
import NotFoundPage from './pages/public/NotFoundPage'; 
import Login from './pages/public/Login'; 

// *** NEW MVP UTILITY PAGES ***
import AboutProject from './pages/public/AboutProject'; // Explains the MVP's purpose
import DashboardFeature from './pages/public/DashboardFeature'; // The main functional feature (e.g., token tracker)
import TermsOfUse from './pages/public/TermsOfUse'; // Standard legal page
import GroomingServicesDoge from './pages/public/GroomingServicesDoge'; // <--- NEW IMPORT


// --- Security Components (Kept for Dev/Admin access) ---
import ProtectedRoute from './components/Auth/ProtectedRoute'; 
import AdminDashboard from './pages/admin/AdminDashboard'; // Small admin area for MVP management
import Navbar from './components/Layout/Navbar';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        {/* 1. CORE MVP PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        
        {/* The main functional feature of the MVP */}
        <Route path="/dashboard" element={<DashboardFeature />} /> 
        
        {/* 2. INFORMATIONAL & UTILITY ROUTES */}
        <Route path="/about" element={<AboutProject />} /> 
        <Route path="/contact" element={<ContactPage />} /> 
        <Route path="/terms" element={<TermsOfUse />} /> 
        <Route path="/book" element={<GroomingServicesDoge />} /> {/* <--- NEW ROUTE */}
                
        {/* 3. LOGIN & AUTH */}
        <Route path="/login" element={<Login />} /> 
        
        {/* 4. PROTECTED ADMIN ROUTE (For development/management access) */}
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route path="/admin" element={<AdminDashboard />} /> 
        </Route>

        {/* 5. Catch-all for 404 Not Found pages */}
        <Route path="*" element={<NotFoundPage />} /> 
      </Routes>
    </>
  );
}

export default App;
